module.exports = __webpack_public_path__ + "img/investec-logo.471aee78.svg";